import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { RoutePaths } from "../enums";
import { companyIdSelector } from "../recoil";

export const usePrefixedRouting = () => {
  const navigate = useNavigate();
  const currentCompanyId = useRecoilValue(companyIdSelector);
  const prefix: string = useMemo(() => {
    if (currentCompanyId) {
      return `/c/${currentCompanyId}`;
    }

    return "/";
  }, [currentCompanyId]);

  const addPrefix = useCallback(
    (routeRaw: string): string => {
      if (routeRaw?.startsWith(prefix)) {
        return routeRaw;
      }

      if (!routeRaw?.trim() || routeRaw === RoutePaths.HOME) {
        return prefix;
      }

      if (routeRaw.startsWith("/")) {
        return `${prefix}${routeRaw}`;
      }

      return `${prefix}/${routeRaw}`;
    },
    [prefix],
  );

  const navigatePrefixed = useCallback(
    (url: string) => {
      if ((!url || url === RoutePaths.HOME) && !currentCompanyId) {
        /* navigate to blank page (profile modal background) instead of dashboard
             after login with no company selected */
        navigate(url || RoutePaths.HOME);
        return;
      }

      navigate(addPrefix(url));
    },
    [addPrefix, currentCompanyId, navigate],
  );
  return { prefix, addPrefix, navigatePrefixed };
};
